import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { Subject } from '../../../../node_modules/rxjs/Subject';
import { Subscription } from '../../../../node_modules/rxjs/Subscription';
import { Banner } from '../banner.model';
import { Observer } from '../../../../node_modules/rxjs/Observer';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '../../../../node_modules/@angular/router';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';
import { MatPaginatorIntl } from '../../../../node_modules/@angular/material';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { ImagenBanner } from '../banner-imagen-upload/imagen-banner.model';
import { ClienteService } from '../../core/cliente.service';
import { DomSanitizer } from '../../../../node_modules/@angular/platform-browser';

interface Filters {
  page: number;
  size: number;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-bannerlist',
  templateUrl: './bannerlist.component.html',
  styleUrls: ['./bannerlist.component.scss']
})
@Injectable()
export class BannerlistComponent implements OnInit {

  private filters: Filters = {
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  public showFilters = true;
  isMobile: boolean;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  bannersList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Banner, Banner.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Banner[]>;

  constructor(
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private clienteService: ClienteService,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService,
    private snackService: SnackService
  ) {
  }

  async ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    await this.bannersList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
      t.forEach(b => {
        this.getImages(b.imagen);
      });
    });

    this.refreshRoleList();

  }

  getImages(imagen: ImagenBanner) {
    this.clienteService.getImagenBannerById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.url = safeUrl;
    });
  }

  refreshRoleList() {
    this.bannersList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      page: 0,
      size: 50,
      sort: 'created,desc'
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  detallesBanner(id: number) {
    this.router.navigate(['/banner', id]);
  }

  onAddBanner() {
    this.router.navigate(['/banner/agregar']);
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

  removeChip(event) {
    this.refreshRoleList();
  }

  clearSearch() {
    this.refreshRoleList();
  }

  async confirmEliminar(id: number) {
    this.dialogService.confirm('Eliminar Banner',
    '¿Está seguro que desea eliminar este banner?')
    .then( res => {
      if (res) {
        this.deleteBanner(res, id);
      }
    });
  }

  async deleteBanner(res, id) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Banner.path + 'eliminar/' + id);
        this.snackService.success('Banner eliminado correctamente');
        this.refreshRoleList();
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/bannerlist/bannerlist.component.ts